import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// import {LOGIN_AUTHENICATE2_API,BASE_URL,LOGIN_OTP_AUTHENTICATION,LOGIN_OTP_SUBMIT_AUTHENTICATION} from '../../../Constants/Config'
// // import { useSelector, useDispatch } from "react-redux";
// import Cookies from 'js-cookie';
// import axios from 'axios';

// const initialState = {
//     loading: false,
//     checkemailValidate:false,
//     error:"",
//     EmailValidateOtp:false,
//     CoockieEmailValidate:false,
//     getAuthRecord:[]
// }
// let otp_get_api=BASE_URL+LOGIN_AUTHENICATE2_API
// export const fetchLoginData=createAsyncThunk("LoginAuth/fetchLoginData",async(data)=>{
//     try{
//         const response = await axios.post(otp_get_api, data, { headers: { "Content-Type": "multipart/form-data" } })
//         if (response.status === 200) {
//             // localStorage.setItem('checkemailValidate',response.data);

//             return response.data
//         }

//     }catch(error){
//         console.log(error)//error.response.data.message
//         // throw new Error(error.response.data.message);
//     }
// })

// // OTP CHECK API--------------------------------
// export const handleCheckOTP=createAsyncThunk("LoginAuth/handleCheckOTP",async(data)=>{
//      try{
//           const response = await axios.post(BASE_URL+LOGIN_OTP_AUTHENTICATION, data, {
//             headers: { "Content-Type": "multipart/form-data" },
//           });
//           console.log(response.data)
//         //   localStorage.setItem('emailValidateOtp',);
//         if(response.data)
//         {
//             Cookies.set('emailValidateOtp',JSON.stringify(response.data));
//         }

//         return response.data

//         }catch(error){
//           console.error("Error validating email:", error.message);
//           throw error;
//         }

// }
// )
// // OTP CHECK API--------------------------------
// // after otp api submit----------------------
// // after otp submit-------------------
// export const handleSubmitOtp=createAsyncThunk("LoginAuth/handleSubmitOtp",async(data)=>{
//     try{
//         const response = await axios.post(BASE_URL+LOGIN_OTP_SUBMIT_AUTHENTICATION, data, {
//             headers: { "Content-Type": "multipart/form-data" },
//           });

//         const decodedData =response?.data!==undefined ? JSON.stringify(response.data):'';
//         Cookies.set('AuthsessionData', decodedData);
//         // return response.data

//     }catch(error)
//     {
//         console.error("Error validating email:", error.message);
//         throw error;
//     }

// })
// // after otp submit-------------------

// const LoginSlice = createSlice({
//     name:'LoginAuth',
//     initialState,
//     reducers: {
//        localAuthCheck(state,action) {
//             state.CoockieEmailValidate=action.payload
//         },
//         getAuthSessionRecord(state,action){
//             state.getAuthRecord=action.payload
//         }
//     },
//     extraReducers:(builder)=>{
//         builder.addCase(fetchLoginData.pending,(state)=>{
//             state.loading=true;
//         });
//         builder.addCase(fetchLoginData.fulfilled,(state,action)=>{
//             state.loading=false;
//             state.checkemailValidate=action.payload;
//         })
//         builder.addCase(fetchLoginData.rejected, (state, action) => {
//             state.loading = false;
//             state.error = action.error.message;
//         });
//         // ===================================================
//         builder.addCase(handleCheckOTP.pending,(state)=>{
//             state.loading=true;
//         });
//         builder.addCase(handleCheckOTP.fulfilled,(state,action)=>{
//             state.loading=false;
//             state.EmailValidateOtp=action.payload;
//         })
//         builder.addCase(handleCheckOTP.rejected, (state, action) => {
//             state.loading = false;
//             state.error = action.error.message;
//         });
//         // ================================================
//         // builder.addCase(handleSubmitOtp.pending,(state)=>{
//         //     state.loading=true;
//         // });
//         // builder.addCase(handleSubmitOtp.fulfilled,(state,action)=>{
//         //     state.loading=false;
//         //     state.loginAuthResult=action.payload;
//         // })
//         // builder.addCase(handleSubmitOtp.rejected, (state, action) => {
//         //     state.loading = false;
//         //     state.error = action.error.message;
//         // });

//     }
// })
// export const { localAuthCheck,getAuthSessionRecord } = LoginSlice.actions;

// export default LoginSlice.reducer

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import axios from "axios";
import {
  BASE_URL,
  LOGIN_OTP_SUBMIT_AUTHENTICATION,
  LOGIN_WITH_CODE,
  WEB_LOGIN_CODE,
  SECRET_KEY,
  RESEND_OTP,
} from "../../../Constants/Config";
import { ciUrl } from "../../../Constants/nodeCi";
import {
  persistSessionLoginIdFromCreateSessionResponse,
  clearPersistedSessionLoginId,
} from "../../../Common/persistedLoginId";
import { getAuthDetails } from "../../../Common/cookiesHelper";
import { useNavigate } from "react-router-dom";

const initialState = {
  loading: false,
  getUserRecord: [],
  errors: "",
  getUserLoginRecord: [],
  StoreUserDashboardRecord: [],
};

// Async thunk to handle user authentication
export const handleUserType = createAsyncThunk(
  "LoginAuth/handleUserType",
  async (data, { rejectWithValue }) => {
    const data1 = data;
    try {
      const response = await axios.post(
        ciUrl(LOGIN_OTP_SUBMIT_AUTHENTICATION),
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      // If 2FA OTP is required, return early without setting cookies/localStorage
      if (response.data.otp_required === 1) {
        return response.data;
      }
      if (response.data.status === true) {
        // Clear any stale auth-related local storage only when login actually succeeds
        clearPersistedSessionLoginId();
        localStorage.removeItem("AllStore");
        localStorage.removeItem("permissions");
        localStorage.removeItem("emp_id");

        // Save device_token to localStorage if returned (trusted device)
        if (response.data.device_token) {
          localStorage.setItem("qv_device_token", response.data.device_token);
        }
        let employee_id = response.data?.employee_id;
        if (employee_id !== null && employee_id !== undefined) {
          localStorage.setItem("emp_id", employee_id);
        }
        // Original login user id from create_session — unchanged when switching store (see handleGetStoreRecord).
        persistSessionLoginIdFromCreateSessionResponse(response.data);
        // =============================================
        if (response.data.login_type == "superadmin") {
          const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(response.data),
            SECRET_KEY
          ).toString();
          Cookies.set("loginDetails", encryptedData);
          Cookies.set("token_data", encryptedData);
          Cookies.set("superadmin_details", encryptedData);
        } else {
          // Leftover superadmin cookie from an earlier session in this browser: with the two copies of
          // the new session it pushes the Cookie header past nginx's 8 KB limit (400 on every request).
          Cookies.remove("superadmin_details");
          if (response.data.final_login !== 1) {
            const { stores, ...data } = response?.data?.data;

            const final_login = response.data.final_login;
            const status = response.data.status;
            const storesNew = response.data.data.stores.slice(0, 4);
            const newData = { ...data, stores: storesNew };
            // const permissions = response.data.permissions

            const dataToStore = {
              data: newData,
              final_login,
              status,
              stores: storesNew,
            };
            // console.log("superadmin", response.data);
            // console.log("dataToStore", dataToStore);
            // =============================================
            // ---------------------------------------------------
            localStorage.setItem(
              "AllStore",
              JSON.stringify(response?.data?.data?.stores)
            );
            // console.log(permissions)
            // localStorage.setItem(
            //   "permissions",
            //   JSON.stringify(permissions)
            // );

            // -------------------------------------------
            // =============================================

            const encryptedData = CryptoJS.AES.encrypt(
              JSON.stringify(dataToStore),
              SECRET_KEY
            ).toString();
            Cookies.set("loginDetails", encryptedData);
            Cookies.set("token_data", encryptedData);
            // Cookies.set("permissions", encryptedData);

            // get data
            // console.log("permissions => ", Cookies.get("permissions"));
          } else {
            // const encryptedData = CryptoJS.AES.encrypt(
            //   JSON.stringify(response?.data),
            //   "secret key"
            // ).toString();
            // Cookies.set("loginDetails", encryptedData);
            // Cookies.set("token_data", encryptedData);
            // ------------------------------------------
            const { data2, ...data } = response?.data;

            const final_login = response.data.final_login;
            const status = response.data.status;
            const storesNew = data2.stores.slice(0, 2);
            const newData = { ...data, stores: storesNew };
            const permissions = response.data.permissions

            const dataToStore = {
              data: response?.data.data,
              token: data?.token,
              token_id: data?.token_id,
              // data:data,
              employee_id: data?.employee_id,
              final_login,
              status,
              stores: storesNew,
              login_type: response?.data.login_type,
              permissions
            };
            // console.log("superadmin", response.data);
            // console.log("dataToStore", dataToStore);
            // =============================================
            // ---------------------------------------------------
            localStorage.setItem("AllStore", JSON.stringify(data2?.stores));
            // console.log(permissions)
            // localStorage.setItem(
            //   "permissions",
            //   JSON.stringify(permissions)
            // );

            // -------------------------------------------
            // =============================================

            const encryptedData = CryptoJS.AES.encrypt(
              JSON.stringify(dataToStore),
              SECRET_KEY
            ).toString();
            Cookies.set("loginDetails", encryptedData);
            Cookies.set("token_data", encryptedData);
            // Cookies.set("permissions", encryptedData);

            // get data

            // ------------------------------------------
          }
        }

        if (
          response.data.permissions
          // &&
          // ["manager", "cashier", "driver", "time_clock_only", "superadmin"].includes(
          //   response.data.login_type
          // )
        ) {
          // let permissions = response.data.permissions;
          let permissions = Array.isArray(response?.data?.permissions) ?
            response.data.permissions.join(",") :
            response.data.permissions;
          // Encrypt permissions before storing in localStorage
          const encryptedPermissions = CryptoJS.AES.encrypt(
            permissions,
            SECRET_KEY
          ).toString();
          localStorage.setItem("permissions", encryptedPermissions);
        }
        // Store user authentication record in local storage
        const encoded = btoa(JSON.stringify(data1)); // data1 => store name, username, password
        Cookies.set("user_auth_record", encoded);
        // const permissions = "NO,VE,CA,RE,CF,QU,CH,DI,OT,CT,CR,CL,CD,ID,AT,FO,CE,GI,CI,CB,LT,21,AE,ME,TI,DE,CV,UV,PV,AV,AO,UO,RO,C,AC,AU,UU,PU,RU,IP,DP,ST,SE,SY,AL,OP,SC,IS,AS,PT,PS,HA,QA,T,MR,GC,SS,RG,O,D,CU,TC,GB,RB,VD,RF,UP,CO,EO,VI,EP,RP,VP,AP,AR,SA,IN,PA,RA,RR,LR,SR,GR,TR,EH,DG,CM,ER,PL,DDD,AK,CK,VK,EK,OK,ALP,EL,AB,EB,DB,AMM,AM,EM,DM,AZRYT,SDFSD,SDQWE"

        return response.data;
      } else {
        return response.data;
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const handleGetStoreRecord = createAsyncThunk(
  "LoginAuth/handleGetStoreRecord",
  async (data) => {
    // Inject device_token for trusted device check on multi-store login
    const storedDeviceToken = localStorage.getItem("qv_device_token");
    if (storedDeviceToken) {
      data.device_token = storedDeviceToken;
    }
    try {
      const response = await axios.post(
        ciUrl(LOGIN_OTP_SUBMIT_AUTHENTICATION),
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.data.status === true && response.data.otp_required == 0) {
        // Save device_token if returned (trusted device)
        if (response.data.device_token) {
          localStorage.setItem("qv_device_token", response.data.device_token);
        }
        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(response?.data),
          SECRET_KEY
        ).toString();
        Cookies.set("token_data", encryptedData);
      }
      return response.data;
    } catch (error) {
      console.error("Error validating email:", error.message);
      throw error;
    }
  }
);

// Redeems a one-time login code from the POS webview dashboard button
// (LoginApiReact/web_login_code) — see LOGIN_WITH_CODE in Constants/Config.js.
// Persists exactly what handleUserType does for a non-superadmin final_login=1 login
// (merchant, admin or employee); a code never comes back superadmin or mid-store-selection.
// user_auth_record carries only { username } (the login email) — a code login never carries a password.
export const loginWithCode = createAsyncThunk(
  "LoginAuth/loginWithCode",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(ciUrl(LOGIN_WITH_CODE), data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data?.status === true) {
        clearPersistedSessionLoginId();
        localStorage.removeItem("AllStore");
        localStorage.removeItem("permissions");
        localStorage.removeItem("emp_id");

        const employee_id = response.data?.employee_id;
        if (employee_id !== null && employee_id !== undefined) {
          localStorage.setItem("emp_id", employee_id);
        }
        persistSessionLoginIdFromCreateSessionResponse(response.data);

        const stores = Array.isArray(response.data?.data2?.stores)
          ? response.data.data2.stores
          : [];
        // login_email is the person who signed in. data.email is the store
        // address. getManagerStores looks up stores by the login email.
        const posLoginUserEmail = String(response.data?.login_email || "").trim();
        const dataToStore = {
          data: response.data.data,
          token: response.data.token,
          token_id: response.data.token_id,
          employee_id,
          final_login: response.data.final_login,
          status: response.data.status,
          stores: stores.slice(0, 2),
          login_type: response.data.login_type,
          login_email: posLoginUserEmail,
          permissions: response.data.permissions,
          // No password behind this session: Header switches store via switchStoreWithCode.
          login_via_code: 1,
        };
        localStorage.setItem("AllStore", JSON.stringify(stores));
        const encryptedData = CryptoJS.AES.encrypt(
          JSON.stringify(dataToStore),
          SECRET_KEY
        ).toString();
        Cookies.set("loginDetails", encryptedData);
        Cookies.set("token_data", encryptedData);
        Cookies.remove("superadmin_details");

        if (response.data.permissions) {
          const permissions = Array.isArray(response.data.permissions)
            ? response.data.permissions.join(",")
            : response.data.permissions;
          localStorage.setItem(
            "permissions",
            CryptoJS.AES.encrypt(permissions, SECRET_KEY).toString()
          );
        }

        // user_auth_record is the login identity other screens already read.
        // Prefer the POS login email; the store address is only a last resort
        // so a session with no login_email still has a username.
        const loginEmail = String(
          posLoginUserEmail ||
          response.data?.data?.email ||
          ""
        ).trim();
        if (loginEmail) {
          Cookies.set("user_auth_record", btoa(JSON.stringify({ username: loginEmail })));
        } else {
          Cookies.remove("user_auth_record");
        }
      }
      return response.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

// A code session (POS webview) has no password to re-run create_session with, so it changes store by
// asking web_login_code for a code on the target store and redeeming it like the POS does.
export const switchStoreWithCode = createAsyncThunk(
  "LoginAuth/switchStoreWithCode",
  async (targetMerchantId, { dispatch }) => {
    const { LoginGetDashBoardRecordJson, userTypeData } = getAuthDetails();
    const sessionMerchantId = LoginGetDashBoardRecordJson?.data?.merchant_id;
    try {
      const response = await axios.post(
        BASE_URL + WEB_LOGIN_CODE,
        {
          merchant_id: sessionMerchantId,
          login_merchant_id: sessionMerchantId,
          login_type: userTypeData?.login_type,
          token_id: userTypeData?.token_id,
          target_merchant_id: targetMerchantId,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userTypeData?.token}`,
          },
        }
      );
      const { status, login_code, login_code_id, msg } = response?.data || {};
      if (status !== true || !login_code || !login_code_id) {
        return { status: false, msg: msg || "Could not switch store." };
      }
      return await dispatch(loginWithCode({ login_code, login_code_id })).unwrap();
    } catch (error) {
      return {
        status: false,
        msg: error?.data?.msg || error?.response?.data?.msg || "Could not switch store.",
      };
    }
  }
);

// Async thunk to resend OTP for 2FA
export const resendOTP = createAsyncThunk(
  "LoginAuth/resendOTP",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(BASE_URL + RESEND_OTP, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const LoginSlice = createSlice({
  name: "LoginAuth",
  initialState: initialState,
  reducers: {
    getAuthSessionRecord(state, action) {
      state.getUserRecord = action.payload;
    },
    getAuthInvalidMessage(state, action) {
      state.errors = action.payload;
    },
    getUserRecordData(state, action) {
      state.getUserLoginRecord = action.payload;
    },
    getUserDashboardRecord(state, action) {
      state.StoreUserDashboardRecord = action.payload;
    },
  },
});

export const {
  getAuthSessionRecord,
  getAuthInvalidMessage,
  getUserRecordData,
  getUserDashboardRecord,
} = LoginSlice.actions;
export default LoginSlice.reducer;
